module.exports = __webpack_public_path__ + "img/tiktok-example-5.474bed25.png";